import React from 'react';
import { CAR_BRAND_STATE, None, ANOTHER } from '../../constants';
import { loadLocal, getDiscountPrice } from '../../utilites';

export default () => {
  const savedCar = loadLocal(CAR_BRAND_STATE);
  const minSliderLength = 6;
  const carsArray = startup.cars.filter((el) => el.Car.StatusId !== 'Sold');
  const { dictionary, language } = startup;
  let filteredCars = [];
  if (savedCar) {
    filteredCars = carsArray.filter((el) => el.Car.Brand === savedCar.Brand);
    if (savedCar.Model !== None && filteredCars.length < minSliderLength)
      filteredCars = filteredCars.filter(
        (el) => el.Car.Model === savedCar.Model
      );
  }
  const featuredVehicles =
    filteredCars.length < minSliderLength
      ? Array.from(new Set(filteredCars.concat(carsArray)))
      : filteredCars;
  return featuredVehicles.map((item) => {
    const title =
      item.Car.Model !== ANOTHER
        ? `${item.Car.Brand} ${item.Car.Model}`
        : item.Car.Brand;
    return (
      <div className="b-goods-f b-goods-f_mod-b" key={item.Car.Id}>
        <div className="b-goods-f__media overflow-hidden">
          <a
            href={`../${startup.language}/vehicle-details/${item.Car.Id}/${item.Car.Brand}-${item.Car.Model}`}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="b-goods-f__img car-image"
              src={item.Images[0].FileName}
              alt={title}
            />
            <span className="b-goods-f__media-inner">
              {item.Car.StatusId === 'Sold' ? (
                ''
              ) : (
                <span className="b-goods-f__favorite">
                  <a
                    href={`../../${language}/leasing?carPrice=${item.Car.Price}&carId=${item.Car.Id}&carModel=${item.Car.Brand}-${item.Car.Model}`}
                  >
                    {dictionary.Leasing}
                  </a>
                </span>
              )}
            </span>
          </a>
        </div>
        <div className="b-goods-f__main">
          <div className="b-goods-f__descrip">
            <div className="b-goods-f__title">
              <span>{title}</span>
            </div>
            <ul className="b-goods-f__list list-unstyled">
              <li className="b-goods-f__list-item">
                <i className="ic flaticon-speedometer" />
                {`${item.Car.Mileage}km.`}
              </li>
              <li className="b-goods-f__list-item">
                <i className="ic flaticon-car-1" />
                {`${dictionary.Model}: ${item.Car.Year}`}
              </li>
              <li className="b-goods-f__list-item">
                <i className="ic flaticon-gearshift" />
                {dictionary[item.Car.TransmissionId]}
              </li>
            </ul>
          </div>
          <div className="b-goods-f__sidebar">
            <span className="b-goods-f__price-group">
              <span className="b-goods-f__price">
              <span className="b-goods-f__price-numb">
                  {`€`}
                    {item.Car.Price}
                </span>
                {/*<span className="b-goods-f__price-numb">
                  {`€ `}
                  <s>
                    {item.Car.Price}
                  </s>
                </span>
                <span className="b-goods-f__price-numb discount-price">
                  {` ${getDiscountPrice(item.Car.Price)}`}
                </span>*/}
              </span>
            </span>
          </div>
        </div>
      </div>
    );
  });
};
